/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcFundingV1BatchAllocationEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_FUNDING_V1_BATCH_ALLOCATION_EVENT_ENTITY_NAME = 'ixc.funding.v1.BatchAllocationEvent';
export const ixcFundingV1BatchAllocationEventEntity = new schema.Entity<IxcFundingV1BatchAllocationEvent>(IXC_FUNDING_V1_BATCH_ALLOCATION_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcFundingV1BatchAllocationEvent) => `${entity.metadata?.eventId}` });

